import { SessionResponse } from '@api/generated/internal/internalApi'

/**
 * Whether a session belongs to the current user.
 */
function isOwnSession(session: SessionResponse, currentUserId?: string): boolean {
  return !session.userId || session.userId === currentUserId
}

/**
 * A session's activity time: its latest message, falling back to its creation time when it has no
 * messages yet.
 */
function sessionActivityTime(session: SessionResponse): string {
  return session.latestMessageDate ?? session.createdDate
}

/**
 * Picks the default session to load when the chat URL has no session query param, like
 * when the user returns from the Teammate Builder.
 */
export function selectDefaultSessionId(sessions: SessionResponse[] | undefined, currentUserId?: string): string | undefined {
  const ownSessions = sessions?.filter(session => isOwnSession(session, currentUserId))
  if (!ownSessions || ownSessions.length === 0) return undefined

  const newest = ownSessions.reduce((latest, session) =>
    sessionActivityTime(session).localeCompare(sessionActivityTime(latest)) > 0 ? session : latest
  )
  return newest.id
}
